/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DelegatorsInfo
 */
export interface DelegatorsInfo {
    /**
     * 
     * @type {string}
     * @memberof DelegatorsInfo
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof DelegatorsInfo
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof DelegatorsInfo
     */
    shares: string;
    /**
     * 
     * @type {number}
     * @memberof DelegatorsInfo
     */
    percent: number;
    /**
     * 
     * @type {boolean}
     * @memberof DelegatorsInfo
     */
    self: boolean;
}

export function DelegatorsInfoFromJSON(json: any): DelegatorsInfo {
    return DelegatorsInfoFromJSONTyped(json, false);
}

export function DelegatorsInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegatorsInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'amount': json['amount'],
        'shares': json['shares'],
        'percent': json['percent'],
        'self': json['self'],
    };
}

export function DelegatorsInfoToJSON(value?: DelegatorsInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'amount': value.amount,
        'shares': value.shares,
        'percent': value.percent,
        'self': value.self,
    };
}


